module.exports = __webpack_public_path__ + "img/aktiviti-kelapa-pandan.52d5b501.png";